module.exports = __webpack_public_path__ + "img/manager.cef0b052.svg";